import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Modal from '../Modal';
import Survey from '../../../../../shared/components/Survey';
import styles from './SurveyModal.module.scss';
/**
 * SurveyModal component - displays survey inside a modal
 * @param {SurveyModalProps} props - Component props
 * @returns {JSX.Element | null} SurveyModal component
 */
const SurveyModal = ({ isOpen, onClose, surveyUrl, onSubmit, onSkip, }) => {
    return (_jsx(Modal, { isOpen: isOpen, onClose: onClose, secondaryButtonText: "Not at this time", onSecondaryClick: onSkip, children: _jsxs("div", { className: styles.surveyContainer, children: [_jsxs("div", { className: styles.surveyHeader, children: [_jsx("h2", { className: styles.title, children: "Help us learn more about your needs" }), _jsx("p", { className: styles.subtitle, children: "Your feedback is valuable to us. Please answer the 3 quick questions." })] }), _jsx("div", { className: styles.surveyContent, children: _jsx(Survey, { surveyUrl: surveyUrl, onSubmit: onSubmit, showHeader: false }) })] }) }));
};
export default SurveyModal;
